import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DealersUserDetail from './components/DealersUserDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageDealersUser',
  components: {
    DealersUserDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;